import React from 'react'
import HeroBanner from '../component/Common Banner Component/HeroBanner'
import Footer from '../component/Footer/Footer'
import Contactform from '../component/Contact Form/Contactform'
import DecoratingInteriorDesign from '../component/DecoratingInteriorDesign/DecoratingInteriorDesign'
import { Helmet } from 'react-helmet'
import DesignInerior from '../component/DesignInerior/DesignInerior'

function Design() {
    return (
        <>
                      
            <Helmet>
                <title> 
                Interior Design Services | Residential & Commercial Designers
                </title>
                <meta 
                name='description' 
                content="Expert interior design services for residential and commercial spaces. Transform your home or workspace with bespoke design solutions tailored to your style." 
                />
                <link rel="canonical" href="https://www.mesdecors.ca/design" />
                </Helmet>
        
            <HeroBanner 
                subHeading=""
                Heading="Design"
                nextLineSpanHeading=""
                Paragraph=""
                bgImg="/images/creatives/design-hero-bg.png"
                btn={false}
                sideLinks={false}
            />
    
          <DesignInerior
            heading="A BROAD SET OF INTERIOR DESIGN"
            content="At MES Décors, we believe that every space tells a story. As a full-service Interior Design Studio, we specialize in interior bespoke design solutions that transform ordinary spaces into extraordinary experiences. Whether you're looking to refresh your home, stage a property for sale, or enhance your commercial space, our expert team is here to bring your vision to life."
            

          />

          <div className='container text-center standard-padding-space pt-0'>
            <h3 className='body-heading'>INTERIOR DESIGN SERVICES</h3>
            <p className='body-paragraph' style={{fontSize:"1.2rem"}}>Interior design isn’t one-size-fits-all. Every project is unique in scope, size, and complexity, which is why set packages don’t work. To ensure you get the best value and stay in control, we offer personalized quotes after a FREE consultation, allowing us to tailor our services to your exact needs, whether residential or commercial.</p>

          </div>
           
          <Contactform/>
          <Footer
            newsletterSection={true}
          />
        </>
      )
}

export default Design